import { render } from "./createinvoices.vue?vue&type=template&id=af21eb0a"
import script from "./createinvoices.vue?vue&type=script&lang=js"
export * from "./createinvoices.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__